import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import App from './App.tsx';
import './index.css';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { LanguageProvider } from './contexts/LanguageContext.tsx';
import { ThemeProvider } from './contexts/ThemeContext.tsx';
import { MaintenanceProvider } from './contexts/MaintenanceContext.tsx';
import MaintenanceWrapper from './components/MaintenanceWrapper.tsx';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ThemeProvider>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <AuthProvider>
          <MaintenanceProvider>
            <BrowserRouter>
              <MaintenanceWrapper>
                <App />
              </MaintenanceWrapper>
            </BrowserRouter>
          </MaintenanceProvider>
        </AuthProvider>
      </TooltipProvider>
    </LanguageProvider>
  </ThemeProvider>
);